import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('app', () => {
  const locale = ref('ru')
  const isMobileMenuOpen = ref(false)

  const currentLocale = computed(() => locale.value)

  function setLocale(lang: string) {
    locale.value = lang
    localStorage.setItem('locale', lang)
  }

  function initLocale() {
    const saved = localStorage.getItem('locale')
    if (saved) {
      locale.value = saved
    } else {
      const browserLang = navigator.language
      if (browserLang.startsWith('zh')) {
        locale.value = browserLang === 'zh-TW' || browserLang === 'zh-HK' ? 'zh-TW' : 'zh-CN'
      } else if (browserLang.startsWith('ru')) {
        locale.value = 'ru'
      } else {
        locale.value = 'en'
      }
    }
  }

  function toggleMobileMenu() {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
  }

  return {
    locale,
    isMobileMenuOpen,
    currentLocale,
    setLocale,
    initLocale,
    toggleMobileMenu
  }
})
